import React from "react";
import { Box, Typography } from "convertupleads-theme";

const PageTitleBox = ({ title, description }) => {
  return (
    <Box p={3}>
      <Typography variant={"h3"} color={"text.primary"} mb={1}>
        {title}
      </Typography>
      <Typography variant={"body2"} color={"text.primary"}>
        {description}
      </Typography>
    </Box>
  );
};

export default PageTitleBox;
